function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'dark-grey': 'rgb(46, 47, 56)','black': 'rgb(0, 0, 0)','green': 'rgb(50, 76, 72)','navy': 'rgb(29, 49, 75)','grey': 'rgb(128, 128, 128)','burgundy': 'rgb(128, 0, 32)','black-with-black-collar-piping': 'rgb(0, 0, 0)','black-with-white-piping': 'rgb(0, 0, 0)','navy-with-navy-collar-piping': 'rgb(29, 49, 75)','navy-with-green-collar-with-white-piping': 'rgb(29, 49, 75)','green-with-white-piping': 'rgb(50, 76, 72)','dark-grey-with-white-collar-piping': 'rgb(46, 47, 56)','electric-blue-with-white-collar-piping': 'rgb(70, 83, 146)','steel-blue-with-white-piping': 'rgb(61, 111, 165)','republic-blue': 'rgb(50, 51, 74)','chocolate': 'rgb(62, 49, 42)','navy-with-navy-collar-with-white-piping': 'rgb(29, 49, 75)','beige': 'rgb(179, 169, 161)','light-grey': 'rgb(195, 204, 207)','bordeaux': 'rgb(80, 37, 47)','jungle-green': 'rgb(50, 68, 66)','sailor-blue': 'rgb(24, 58, 90)','french-blue': 'rgb(109, 127, 144)','light-pink': 'rgb(189, 156, 164)','khaki-green': 'rgb(63, 74, 75)','electric-blue': 'rgb(70, 83, 146)','eggplant': 'rgb(88, 46, 68)','fauve': 'rgb(165, 69, 47)','dark-purple': 'rgb(58, 23, 55)','beige-with-silver': 'rgb(245, 230, 226)','navy-with-silver': 'rgb(202, 207, 235)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
